import {Cookies} from "react-cookie";

/**
 * Class for instantiating and accessing a singleton instance of cookie.
 */
export default class GlobalCookie {
  
  static cookie = null;

  static getInstance() {
    if (GlobalCookie.cookie == null) {
        GlobalCookie.cookie = new Cookies();
    }

    return this.cookie;
  }

}
